"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kette = void 0;
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const echain_shared_2d_shapes_1 = require("@igus/echain-shared-2d-shapes");
const Article_1 = require("../Article");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const StaticIA_1 = require("../ia/StaticIA");
const echain_product_models_1 = require("@igus/echain-product-models");
/**
 * @deprecated directly work with `KetteUnion` or derived types.
 */
class Kette extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'Kette';
    }
    get serieType() {
        return this.model.KetteSerieType;
    }
    set referenceKetteJson(value) {
        this.model.ReferenceKetteJson = value;
    }
    get referenceKetteJson() {
        return this.model.ReferenceKetteJson;
    }
    set bestTyp(value) {
        this.model.BestTyp = value;
    }
    get bestTyp() {
        return this.model.BestTyp;
    }
    set serienKurzbezeichnung(value) {
        this.model.SerienKurzbezeichnung = value;
    }
    get serienKurzbezeichnung() {
        return this.model.SerienKurzbezeichnung;
    }
    set serieRef(value) {
        this.model.SerieRef = Object.assign(Object.assign({}, (value.id ? { Id: value.id } : {})), (value.kuerzel ? { Kuerzel: value.kuerzel } : {}));
    }
    get serieRef() {
        var _a, _b;
        return Object.assign(Object.assign({}, (((_a = this.model.SerieRef) === null || _a === void 0 ? void 0 : _a.Id) ? { id: this.model.SerieRef.Id } : {})), (((_b = this.model.SerieRef) === null || _b === void 0 ? void 0 : _b.Kuerzel) ? { kuerzel: this.model.SerieRef.Kuerzel } : {}));
    }
    set rinneRef(value) {
        this.model.RinneRef = value;
    }
    get rinneRef() {
        return this.model.RinneRef;
    }
    set montagesetRef(value) {
        this.model.MontagesetRef = value;
    }
    get montagesetRef() {
        return this.model.MontagesetRef;
    }
    set rinnenvarianteRef(value) {
        this.model.RinnenvarianteRef = value.map((v) => ({
            Name: v.name,
            RinneRef: v.rinneRef,
            MontagesetRef: v.montagesetRef,
        }));
    }
    get rinnenvarianteRef() {
        return this.model.RinnenvarianteRef.map((v) => ({
            name: v.Name,
            rinneRef: v.RinneRef,
            montagesetRef: v.MontagesetRef,
        }));
    }
    set indexBreite(value) {
        this.model.IndexBreite = value;
    }
    get indexBreite() {
        return this.model.IndexBreite;
    }
    set indexBiegeradius(value) {
        this.model.IndexBiegeradius = value;
    }
    get indexBiegeradius() {
        return this.model.IndexBiegeradius;
    }
    set artSerieBreite(value) {
        this.model.ArtSerieBreite = value;
    }
    get artSerieBreite() {
        return this.model.ArtSerieBreite;
    }
    set gleitenderBetriebErlaubt(value) {
        this.model.GleitenderBetriebErlaubt = value;
    }
    get gleitenderBetriebErlaubt() {
        return this.model.GleitenderBetriebErlaubt;
    }
    set freitragenderBetriebErlaubt(value) {
        this.model.FreitragenderBetriebErlaubt = value;
    }
    get freitragenderBetriebErlaubt() {
        return this.model.FreitragenderBetriebErlaubt;
    }
    set ungeradeAnzahlGlieder(value) {
        this.model.UngeradeAnzahlGlieder = value;
    }
    get ungeradeAnzahlGlieder() {
        return this.model.UngeradeAnzahlGlieder;
    }
    set versatzFestpunktErlaubt(value) {
        this.model.VersatzFestpunktErlaubt = value;
    }
    get versatzFestpunktErlaubt() {
        return this.model.VersatzFestpunktErlaubt;
    }
    set teilung(value) {
        this.model.Teilung = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get teilung() {
        return echain_shared_quantities_1.Q.optional(this.model.Teilung) || echain_shared_quantities_1.Q.optional(this.model.Teilung_mm, 'mm');
    }
    set aussenhoehe(value) {
        this.model.Aussenhoehe = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get aussenhoehe() {
        return echain_shared_quantities_1.Q.optional(this.model.Aussenhoehe) || echain_shared_quantities_1.Q.optional(this.model.Aussenhoehe_mm, 'mm');
    }
    set innenhoehe(value) {
        this.model.Innenhoehe = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get innenhoehe() {
        return echain_shared_quantities_1.Q.optional(this.model.Innenhoehe) || echain_shared_quantities_1.Q.optional(this.model.Innenhoehe_mm, 'mm');
    }
    set iproProduktgruppenId(value) {
        this.model.IproProduktgruppenId = value;
    }
    get iproProduktgruppenId() {
        return this.model.IproProduktgruppenId;
    }
    set iproProduktId(value) {
        this.model.IproProduktId = value;
    }
    get iproProduktId() {
        return this.model.IproProduktId;
    }
    set biegeradius(value) {
        this.model.Biegeradius = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get biegeradius() {
        return echain_shared_quantities_1.Q.optional(this.model.Biegeradius) || echain_shared_quantities_1.Q.optional(this.model.Biegeradius_mm, 'mm');
    }
    set aussenbreite(value) {
        this.model.Aussenbreite = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get aussenbreite() {
        return echain_shared_quantities_1.Q.optional(this.model.Aussenbreite) || echain_shared_quantities_1.Q.optional(this.model.Aussenbreite_mm, 'mm');
    }
    set innenbreite(value) {
        this.model.Innenbreite = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get innenbreite() {
        return echain_shared_quantities_1.Q.optional(this.model.Innenbreite) || echain_shared_quantities_1.Q.optional(this.model.Innenbreite_mm, 'mm');
    }
    set k(value) {
        this.model.K = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get k() {
        return echain_shared_quantities_1.Q.optional(this.model.K) || echain_shared_quantities_1.Q.optional(this.model.K_mm, 'mm');
    }
    set k2(value) {
        this.model.K2 = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get k2() {
        return echain_shared_quantities_1.Q.optional(this.model.K2) || echain_shared_quantities_1.Q.optional(this.model.K2_mm, 'mm');
    }
    set k3(value) {
        this.model.K3 = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get k3() {
        return echain_shared_quantities_1.Q.optional(this.model.K3) || echain_shared_quantities_1.Q.optional(this.model.K3_mm, 'mm');
    }
    set bi1(value) {
        this.model.Bi1 = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get bi1() {
        return echain_shared_quantities_1.Q.optional(this.model.Bi1) || echain_shared_quantities_1.Q.optional(this.model.Bi1_mm, 'mm');
    }
    set bi2(value) {
        this.model.Bi2 = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get bi2() {
        return echain_shared_quantities_1.Q.optional(this.model.Bi2) || echain_shared_quantities_1.Q.optional(this.model.Bi2_mm, 'mm');
    }
    set d1Klein(value) {
        this.model.D1Klein = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get d1Klein() {
        return echain_shared_quantities_1.Q.optional(this.model.D1Klein) || echain_shared_quantities_1.Q.optional(this.model.D1Klein_mm, 'mm');
    }
    set d2Klein(value) {
        this.model.D2Klein = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get d2Klein() {
        return echain_shared_quantities_1.Q.optional(this.model.D2Klein) || echain_shared_quantities_1.Q.optional(this.model.D2Klein_mm, 'mm');
    }
    get contractedLength() {
        return echain_shared_quantities_1.Q.optional(this.model.ContractedLength) || echain_shared_quantities_1.Q.optional(this.model.ContractedLength_mm, 'mm');
    }
    get maxCablesPerChamber() {
        return this.model.MaxCablesPerChamber;
    }
    set gewichtKgProM(value) {
        this.model.GewichtKgProM = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get gewichtKgProM() {
        return echain_shared_quantities_1.Q.optional(this.model.GewichtKgProM) || echain_shared_quantities_1.Q.optional(this.model.GewichtKgProM_kg_m, 'kg_m');
    }
    set leitungDiameterMax(value) {
        this.model.LeitungDiameterMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get leitungDiameterMax() {
        var _a;
        return (_a = echain_shared_quantities_1.Q.optional(this.model.LeitungDiameterMax)) !== null && _a !== void 0 ? _a : echain_shared_quantities_1.Q.optional(this.model.LeitungDiameterMax_mm, 'mm');
    }
    set color(value) {
        this.model.Color = value;
    }
    get color() {
        return this.model.Color;
    }
    set material(value) {
        this.model.Material = value;
    }
    get material() {
        return this.model.Material;
    }
    set langerWeg(value) {
        this.model.LangerWeg = value;
    }
    get langerWeg() {
        return this.model.LangerWeg;
    }
    set langerWegZeichnungsnummer(value) {
        this.model.LangerWegZeichnungsnummer = value;
    }
    get langerWegZeichnungsnummer() {
        var _a, _b;
        return (_b = (_a = this.model.Serie) === null || _a === void 0 ? void 0 : _a.LangerWegZeichnungsnummer) !== null && _b !== void 0 ? _b : this.model.LangerWegZeichnungsnummer;
    }
    set einspeisung(value) {
        this.model.Einspeisung = value;
    }
    get einspeisung() {
        return this.model.Einspeisung;
    }
    set versatz(value) {
        this.model.Versatz = value.quantity;
    }
    get versatz() {
        return (0, echain_shared_quantities_1.Q)(this.model.Versatz) || echain_shared_quantities_1.Q.optional(this.model.Versatz_mm, 'mm');
    }
    set halbstegig(value) {
        this.model.Halbstegig = value;
    }
    get halbstegig() {
        return this.model.Halbstegig;
    }
    set bauform(value) {
        this.model.Bauform = value;
    }
    get bauform() {
        return this.model.Bauform;
    }
    set beschleunigungFLGMax(value) {
        this.model.BeschleunigungFLGMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get beschleunigungFLGMax() {
        return echain_shared_quantities_1.Q.optional(this.model.BeschleunigungFLGMax) || echain_shared_quantities_1.Q.optional(this.model.BeschleunigungFLGMax_m_s2, 'm_s2');
    }
    set geschwindigkeitFLGMax(value) {
        this.model.GeschwindigkeitFLGMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get geschwindigkeitFLGMax() {
        return echain_shared_quantities_1.Q.optional(this.model.GeschwindigkeitFLGMax) || echain_shared_quantities_1.Q.optional(this.model.GeschwindigkeitFLGMax_m_s, 'm_s');
    }
    set beschleunigungFLBMax(value) {
        this.model.BeschleunigungFLBMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get beschleunigungFLBMax() {
        return echain_shared_quantities_1.Q.optional(this.model.BeschleunigungFLBMax) || echain_shared_quantities_1.Q.optional(this.model.BeschleunigungFLBMax_m_s2, 'm_s2');
    }
    set geschwindigkeitFLBMax(value) {
        this.model.GeschwindigkeitFLBMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get geschwindigkeitFLBMax() {
        return echain_shared_quantities_1.Q.optional(this.model.GeschwindigkeitFLBMax) || echain_shared_quantities_1.Q.optional(this.model.GeschwindigkeitFLBMax_m_s, 'm_s');
    }
    set beschleunigungGleitendMax(value) {
        this.model.BeschleunigungGleitendMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get beschleunigungGleitendMax() {
        return (echain_shared_quantities_1.Q.optional(this.model.BeschleunigungGleitendMax) || echain_shared_quantities_1.Q.optional(this.model.BeschleunigungGleitendMax_m_s2, 'm_s2'));
    }
    set geschwindigkeitGleitendMax(value) {
        this.model.GeschwindigkeitGleitendMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get geschwindigkeitGleitendMax() {
        return (echain_shared_quantities_1.Q.optional(this.model.GeschwindigkeitGleitendMax) || echain_shared_quantities_1.Q.optional(this.model.GeschwindigkeitGleitendMax_m_s, 'm_s'));
    }
    set beschleunigungHaengendMax(value) {
        this.model.BeschleunigungHaengendMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get beschleunigungHaengendMax() {
        return (echain_shared_quantities_1.Q.optional(this.model.BeschleunigungHaengendMax) || echain_shared_quantities_1.Q.optional(this.model.BeschleunigungHaengendMax_m_s2, 'm_s2'));
    }
    set geschwindigkeitHaengendMax(value) {
        this.model.GeschwindigkeitHaengendMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get geschwindigkeitHaengendMax() {
        return (echain_shared_quantities_1.Q.optional(this.model.GeschwindigkeitHaengendMax) || echain_shared_quantities_1.Q.optional(this.model.GeschwindigkeitHaengendMax_m_s, 'm_s'));
    }
    set einbauartLangeVerfahrwege(value) {
        this.model.EinbauartLangeVerfahrwege = value;
    }
    get einbauartLangeVerfahrwege() {
        return this.model.EinbauartLangeVerfahrwege;
    }
    set belastungFLG(value) {
        this.model.BelastungFLG = value.map((v) => {
            var _a, _b;
            return ({
                FZ: (_a = v.fz) === null || _a === void 0 ? void 0 : _a.quantity,
                FL: (_b = v.fl) === null || _b === void 0 ? void 0 : _b.quantity,
            });
        });
    }
    get belastungFLG() {
        return this.model.BelastungFLG.map((v) => ({
            fz: echain_shared_quantities_1.Q.optional(v.FZ) || echain_shared_quantities_1.Q.optional(v.FZ_kg_m, 'kg_m'),
            fl: echain_shared_quantities_1.Q.optional(v.FL) || echain_shared_quantities_1.Q.optional(v.FL_mm, 'mm'),
        }));
    }
    set belastungFLB(value) {
        this.model.BelastungFLB = value.map((v) => {
            var _a, _b;
            return ({
                FZ: (_a = v.fz) === null || _a === void 0 ? void 0 : _a.quantity,
                FL: (_b = v.fl) === null || _b === void 0 ? void 0 : _b.quantity,
            });
        });
    }
    get belastungFLB() {
        return this.model.BelastungFLB.map((v) => ({
            fz: echain_shared_quantities_1.Q.optional(v.FZ) || echain_shared_quantities_1.Q.optional(v.FZ_kg_m, 'kg_m'),
            fl: echain_shared_quantities_1.Q.optional(v.FL) || echain_shared_quantities_1.Q.optional(v.FL_mm, 'mm'),
        }));
    }
    set hoeheVorspannung(value) {
        this.model.HoeheVorspannung = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get hoeheVorspannung() {
        return echain_shared_quantities_1.Q.optional(this.model.HoeheVorspannung) || echain_shared_quantities_1.Q.optional(this.model.HoeheVorspannung_mm, 'mm');
    }
    set h(value) {
        this.model.H = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get h() {
        return echain_shared_quantities_1.Q.optional(this.model.H) || echain_shared_quantities_1.Q.optional(this.model.H_mm, 'mm');
    }
    set d(value) {
        this.model.D = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get d() {
        return echain_shared_quantities_1.Q.optional(this.model.D) || echain_shared_quantities_1.Q.optional(this.model.D_mm, 'mm');
    }
    set x1(value) {
        this.model.X1 = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get x1() {
        return echain_shared_quantities_1.Q.optional(this.model.X1) || echain_shared_quantities_1.Q.optional(this.model.X1_mm, 'mm');
    }
    set d1(value) {
        this.model.D1 = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get d1() {
        return echain_shared_quantities_1.Q.optional(this.model.D1) || echain_shared_quantities_1.Q.optional(this.model.D1_mm, 'mm');
    }
    set pushPullForceMax(value) {
        this.model.PushPullForceMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get pushPullForceMax() {
        return echain_shared_quantities_1.Q.optional(this.model.PushPullForceMax) || echain_shared_quantities_1.Q.optional(this.model.PushPullForceMax_N, 'N');
    }
    set fzGleitendMax(value) {
        this.model.FZGleitendMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get fzGleitendMax() {
        return echain_shared_quantities_1.Q.optional(this.model.FZGleitendMax) || echain_shared_quantities_1.Q.optional(this.model.FZGleitendMax_kg_m, 'kg_m');
    }
    set einbauartHaengendMax(value) {
        this.model.EinbauartHaengendMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get einbauartHaengendMax() {
        return echain_shared_quantities_1.Q.optional(this.model.EinbauartHaengendMax) || echain_shared_quantities_1.Q.optional(this.model.EinbauartHaengendMax_mm, 'mm');
    }
    set temperaturMin(value) {
        this.model.TemperaturMin = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get temperaturMin() {
        return echain_shared_quantities_1.Q.optional(this.model.TemperaturMin) || echain_shared_quantities_1.Q.optional(this.model.TemperaturMin_C, '°C');
    }
    set temperaturMax(value) {
        this.model.TemperaturMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get temperaturMax() {
        return echain_shared_quantities_1.Q.optional(this.model.TemperaturMax) || echain_shared_quantities_1.Q.optional(this.model.TemperaturMax_C, '°C');
    }
    set lengthCalcInitializedBy(value) {
        this.model.LengthCalcInitializedBy = value;
    }
    get lengthCalcInitializedBy() {
        return this.model.LengthCalcInitializedBy;
    }
    set verfahrweg(value) {
        this.model.Verfahrweg = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get verfahrweg() {
        return echain_shared_quantities_1.Q.optional(this.model.Verfahrweg) || echain_shared_quantities_1.Q.optional(this.model.Verfahrweg_mm, 'mm');
    }
    set maxAELaenge(value) {
        this.model.MaxAELaenge = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get maxAELaenge() {
        return echain_shared_quantities_1.Q.optional(this.model.MaxAELaenge) || echain_shared_quantities_1.Q.optional(this.model.MaxAELaenge_mm, 'mm');
    }
    set minBauraumGleitendRinneRefs(value) {
        this.model.MinBauraumGleitendRinneRefs = value.map((v) => {
            var _a, _b, _c;
            return ({
                FuehrungsrinneId: v.fuehrungsrinneId,
                FuehrungsrinneTyp: v.fuehrungsrinneTyp,
                FuehrungsrinneStuecklaenge: (_a = v.fuehrungsrinneStuecklaenge) === null || _a === void 0 ? void 0 : _a.quantity,
                MontageSetId: v.montageSetId,
                Breite: (_b = v.breite) === null || _b === void 0 ? void 0 : _b.quantity,
                Hoehe: (_c = v.hoehe) === null || _c === void 0 ? void 0 : _c.quantity,
            });
        });
    }
    get minBauraumGleitendRinneRefs() {
        return this.model.MinBauraumGleitendRinneRefs.map((v) => ({
            fuehrungsrinneId: v.FuehrungsrinneId,
            fuehrungsrinneTyp: v.FuehrungsrinneTyp,
            fuehrungsrinneStuecklaenge: echain_shared_quantities_1.Q.optional(v.FuehrungsrinneStuecklaenge) || echain_shared_quantities_1.Q.optional(v.FuehrungsrinneStuecklaenge_mm, 'mm'),
            montageSetId: v.MontageSetId,
            breite: echain_shared_quantities_1.Q.optional(v.Breite) || echain_shared_quantities_1.Q.optional(v.Breite_mm, 'mm'),
            hoehe: echain_shared_quantities_1.Q.optional(v.Hoehe) || echain_shared_quantities_1.Q.optional(v.Hoehe_mm, 'mm'),
        }));
    }
    set laenge(value) {
        this.model.Laenge = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get laenge() {
        return echain_shared_quantities_1.Q.optional(this.model.Laenge) || echain_shared_quantities_1.Q.optional(this.model.Laenge_mm, 'mm');
    }
    set effektiveLaenge(value) {
        this.model.EffektiveLaenge = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get effektiveLaenge() {
        return echain_shared_quantities_1.Q.optional(this.model.EffektiveLaenge) || echain_shared_quantities_1.Q.optional(this.model.EffektiveLaenge_mm, 'mm');
    }
    set effektiveLaengeWithAEs(value) {
        this.model.EffektiveLaengeWithAEs = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get effektiveLaengeWithAEs() {
        return echain_shared_quantities_1.Q.optional(this.model.EffektiveLaengeWithAEs) || echain_shared_quantities_1.Q.optional(this.model.EffektiveLaengeWithAEs_mm, 'mm');
    }
    set numGlieder(value) {
        this.model.NumGlieder = value;
    }
    get numGlieder() {
        return this.model.NumGlieder;
    }
    set freigabeEIQ(value) {
        this.model.FreigabeEIQ = value;
    }
    get freigabeEIQ() {
        return this.model.FreigabeEIQ;
    }
    set bemerkung(value) {
        this.model.Bemerkung = value;
    }
    get bemerkung() {
        return this.model.Bemerkung;
    }
    set cadLink(value) {
        this.model.CadLink = value;
    }
    get cadLink() {
        return this.model.CadLink;
    }
    set iaFreespace(value) {
        this.model.IAFreespace = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get iaFreespace() {
        return echain_shared_quantities_1.Q.optional(this.model.IAFreespace) || echain_shared_quantities_1.Q.optional(this.model.IAFreespace_mm, 'mm');
    }
    get freigabeEIC() {
        return this.model.FreigabeEIC;
    }
    set freigabeEKE(value) {
        this.model.FreigabeEKE = value;
    }
    get freigabeEKE() {
        return this.model.FreigabeEKE;
    }
    get freigabeEKEManualMode() {
        return this.model.FreigabeEKEManualMode;
    }
    set minDistKlemmO(value) {
        this.model.MinDistKlemmO = value.quantity;
    }
    get minDistKlemmO() {
        return (0, echain_shared_quantities_1.Q)(this.model.MinDistKlemmO) || echain_shared_quantities_1.Q.optional(this.model.MinDistKlemmO_mm, 'mm');
    }
    set minDistKlemmU(value) {
        this.model.MinDistKlemmU = value.quantity;
    }
    get minDistKlemmU() {
        return (0, echain_shared_quantities_1.Q)(this.model.MinDistKlemmU) || echain_shared_quantities_1.Q.optional(this.model.MinDistKlemmU_mm, 'mm');
    }
    set minDistO(value) {
        this.model.MinDistO = value.quantity;
    }
    get minDistO() {
        return (0, echain_shared_quantities_1.Q)(this.model.MinDistO) || echain_shared_quantities_1.Q.optional(this.model.MinDistO_mm, 'mm');
    }
    set minDistU(value) {
        this.model.MinDistU = value.quantity;
    }
    get minDistU() {
        return (0, echain_shared_quantities_1.Q)(this.model.MinDistU) || echain_shared_quantities_1.Q.optional(this.model.MinDistU_mm, 'mm');
    }
    set rastPosDist(value) {
        this.model.RastPosDist = value.quantity;
    }
    get rastPosDist() {
        return (0, echain_shared_quantities_1.Q)(this.model.RastPosDist) || echain_shared_quantities_1.Q.optional(this.model.RastPosDist_mm, 'mm');
    }
    set rastPosLeft(value) {
        this.model.RastPosLeft = value.quantity;
    }
    get rastPosLeft() {
        return (0, echain_shared_quantities_1.Q)(this.model.RastPosLeft) || echain_shared_quantities_1.Q.optional(this.model.RastPosLeft_mm, 'mm');
    }
    set staticIAArtikelRef(value) {
        this.model.StaticIAArtikelRef = value.map((v) => v.toJson());
    }
    get staticIAArtikelRef() {
        return this.model.StaticIAArtikelRef.map((v) => StaticIA_1.StaticIA.fromJson(v));
    }
    set iaNoSpacerBottom(value) {
        this.model.IANoSpacerBottom = value;
    }
    get iaNoSpacerBottom() {
        return this.model.IANoSpacerBottom;
    }
    set iaNoSpacerTop(value) {
        this.model.IANoSpacerTop = value;
    }
    get iaNoSpacerTop() {
        return this.model.IANoSpacerTop;
    }
    set noSeparaterFootBottom(value) {
        this.model.NoSeparaterFootBottom = value;
    }
    get noSeparaterFootBottom() {
        return this.model.NoSeparaterFootBottom;
    }
    set noSeparaterFootTop(value) {
        this.model.NoSeparaterFootTop = value;
    }
    get noSeparaterFootTop() {
        return this.model.NoSeparaterFootTop;
    }
    set standardTrennstegArtNr(value) {
        this.model.StandardTrennstegArtNr = value;
    }
    get standardTrennstegArtNr() {
        return this.model.StandardTrennstegArtNr;
    }
    set isMontageMitnehmer(value) {
        this.model.IsMontageMitnehmer = value;
    }
    get isMontageMitnehmer() {
        return this.model.IsMontageMitnehmer;
    }
    get innerContours() {
        var _a;
        return (_a = this.model.InnerContours) === null || _a === void 0 ? void 0 : _a.map((v) => echain_shared_2d_shapes_1.Contour.fromJson(v));
    }
    set innerContours(value) {
        this.model.InnerContours = value === null || value === void 0 ? void 0 : value.map((v) => v.toJson());
    }
    get triangles() {
        var _a;
        return (_a = this.model.Triangles) === null || _a === void 0 ? void 0 : _a.map((v) => echain_shared_2d_shapes_1.Triangle.fromJson(v));
    }
    set triangles(value) {
        this.model.Triangles = value === null || value === void 0 ? void 0 : value.map((v) => v.toJson());
    }
    set usableIaFillingAreaInPercent(value) {
        this.model.UsableIaFillingAreaInPercent = value;
    }
    get usableIaFillingAreaInPercent() {
        return this.model.UsableIaFillingAreaInPercent;
    }
    set aeussererLeitungsbauraum(value) {
        this.model.AeussererLeitungsbauraum = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get aeussererLeitungsbauraum() {
        return echain_shared_quantities_1.Q.optional(this.model.AeussererLeitungsbauraum) || echain_shared_quantities_1.Q.optional(this.model.AeussererLeitungsbauraum_mm, 'mm');
    }
    set bandwinkel(value) {
        this.model.Bandwinkel = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get bandwinkel() {
        return echain_shared_quantities_1.Q.optional(this.model.Bandwinkel) || echain_shared_quantities_1.Q.optional(this.model.Bandwinkel_deg, 'deg');
    }
    set anzahlBaender(value) {
        this.model.AnzahlBaender = value;
    }
    get anzahlBaender() {
        return this.model.AnzahlBaender;
    }
    set rotationswinkel(value) {
        this.model.Rotationswinkel = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get rotationswinkel() {
        return echain_shared_quantities_1.Q.optional(this.model.Rotationswinkel) || echain_shared_quantities_1.Q.optional(this.model.Rotationswinkel_deg, 'deg');
    }
    set radiusAussen(value) {
        this.model.RadiusAussen = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get radiusAussen() {
        return echain_shared_quantities_1.Q.optional(this.model.RadiusAussen) || echain_shared_quantities_1.Q.optional(this.model.RadiusAussen_mm, 'mm');
    }
    set fixedIaBeat(value) {
        this.model.FixedIaBeat = value;
    }
    get fixedIaBeat() {
        return this.model.FixedIaBeat;
    }
    get iproId() {
        return this.model.IproId;
    }
    /**
     * Helper property to determine if OpeningPrinciple of this kette is 'geschlossen'
     *
     * @readonly
     */
    get geschlossen() {
        return this.model.OpeningPrinciple === echain_shared_articles_1.KetteOpeningPrinciple.Closed;
    }
    static fromScratch(ketteSerieType = echain_shared_articles_1.KetteSerieType.default) {
        return new Kette({
            ArticleType: echain_product_models_1.ArticleType.kette,
            KetteSerieType: ketteSerieType,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
            RinneRef: [],
            MontagesetRef: [],
            RinnenvarianteRef: [],
            BelastungFLG: [],
            BelastungFLB: [],
            LangerWeg: false,
            Einspeisung: echain_shared_articles_1.KetteEinspeisung.mittigeEinspeisung,
            Versatz: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            MinBauraumGleitendRinneRefs: [],
            MinDistKlemmO: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            MinDistKlemmU: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            MinDistO: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            MinDistU: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            RastPosDist: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            RastPosLeft: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            StaticIAArtikelRef: [],
            IsMontageMitnehmer: false,
            Bezeichnung: {},
            Teilung: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            Aussenhoehe: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            Biegeradius: echain_shared_quantities_1.Q.Length.mm(0).quantity,
        });
    }
    static fromExistingArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Kette.fromExistingArtNr: ';
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(args.Id, msg + 'Id: '),
            echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: '),
        ]);
        const kette = Kette.fromJson(args, cloneStrategy);
        kette.artNrExists = true;
        return kette;
    }
    static fromInventedArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Kette.fromInventedArtNrArgs: ';
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: ')]);
        const kette = Kette.fromJson(args, cloneStrategy);
        kette.artNrExists = false;
        return kette;
    }
    static fromJson(args, cloneStrategy = 'deep') {
        const kette = Kette.fromScratch();
        kette.fromJson(args, cloneStrategy);
        return kette;
    }
    static fromModel(model) {
        const kette = Kette.fromScratch();
        // patch the given model ref into the kette model
        Object.assign(kette.model, model);
        // patch the kette model into the given model ref
        Object.assign(model, kette.model);
        // set the kette model to the given model ref
        kette.model = model;
        return kette;
    }
    static fromFilterPropertiesWithVerfahrweg(props) {
        return Kette.fromFilterProperties(props);
    }
    static fromFilterProperties(props) {
        const kette = Kette.fromScratch();
        if (props.verfahrweg_mm != null) {
            kette.verfahrweg = (0, echain_shared_quantities_1.Q)(props.verfahrweg_mm, 'mm');
            kette.lengthCalcInitializedBy = echain_shared_articles_1.KetteLengthCalcInitializedBy.verfahrweg;
        }
        if (props.versatz_mm != null) {
            kette.versatz = (0, echain_shared_quantities_1.Q)(props.versatz_mm, 'mm');
        }
        if (props.langerWeg != null) {
            kette.langerWeg = props.langerWeg;
        }
        if (props.einspeisung != null) {
            kette.einspeisung = props.einspeisung;
        }
        return kette;
    }
    /**
     * Checks if multiple `Leitung` can be layed by this `Kette` regarding dimensions using
     * boolean
     * AND. Result properties will be undefined if decision cannot be made.
     *
     * @param leitungen All leitung objects to check
     * @returns An object with info if it can be layed regarding aussendurchmesser and
     * biegeradius.
     */
    canLayLeitungen(leitungen) {
        const result = {
            aussendurchmesser: undefined,
            biegeradius: undefined,
            rbr: undefined,
        };
        const and = (tar, src) => (tar === undefined ? src : tar && src);
        if (leitungen) {
            for (const leitung of leitungen) {
                const curResult = this.canLayLeitung(leitung);
                result.aussendurchmesser = and(result.aussendurchmesser, curResult.aussendurchmesser);
                result.biegeradius = and(result.biegeradius, curResult.biegeradius);
                result.rbr = and(result.rbr, curResult.rbr);
            }
        }
        return result;
    }
    /**
     * Checks if a `Leitung` can be layed by this `Kette` regarding dimensions. Result properties
     * will
     * be undefined if decision cannot be made.
     *
     * @param leitung The leitung to check
     * @returns An object with info if it can be layed regarding aussendurchmesser and
     * biegeradius.
     */
    canLayLeitung(leitung, currentInnerContourIndex = -1) {
        const result = { aussendurchmesser: true, biegeradius: true, rbr: true };
        switch (this.serieType) {
            case echain_shared_articles_1.KetteSerieType.triflexR:
            case echain_shared_articles_1.KetteSerieType.trxe: {
                // we have the d1, d2, ... values for Triflex, so we have this special handling here
                const innerContourCount = Array.isArray(this.innerContours) ? this.innerContours.length : 0;
                const d1 = this.d1Klein ? this.d1Klein.mm : 0;
                const d2 = this.d2Klein ? this.d2Klein.mm : d1;
                let chamberHeight = 0;
                // if we get a specific chmaber, and chamber-height's differ - we can check correctly ..
                // --> with 2 chambers the height can be different!
                if (currentInnerContourIndex !== -1 && innerContourCount === 2) {
                    // in "Ansicht Festpunkt", the "bigger" chamber is on top
                    // in our innerContours and innerKetteShapes, the first element (idx=0) is the bottom one
                    // in general: d1klein > d2klein
                    // so, idx=0 => bottom => smaller => d2klein
                    // so, idx=1 => top    => bigger  => d1klein
                    chamberHeight = currentInnerContourIndex === 0 ? d2 : d1;
                }
                // but with 3 chambers, all of them have the same height
                else if (innerContourCount === 3)
                    chamberHeight = d1;
                // in all other cases, just take d1klein or the bigger one if available
                else
                    chamberHeight = d1 > d2 ? d1 : d2;
                if (leitung.aussendurchmesser && chamberHeight) {
                    result.aussendurchmesser = leitung.aussendurchmesser.mm <= chamberHeight;
                }
                break;
            }
            case echain_shared_articles_1.KetteSerieType.twisterband:
            case echain_shared_articles_1.KetteSerieType.eskin:
            case echain_shared_articles_1.KetteSerieType.twisterchain:
            case echain_shared_articles_1.KetteSerieType.rolEchain:
            case echain_shared_articles_1.KetteSerieType.default:
            case echain_shared_articles_1.KetteSerieType.rxRohr: {
                // all chain's except triflex have LeitungDiameterMax
                if (leitung.aussendurchmesser && this.leitungDiameterMax) {
                    result.aussendurchmesser = leitung.aussendurchmesser.mm <= this.leitungDiameterMax.mm;
                }
                break;
            }
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(this.serieType);
        }
        if (leitung.biegeradiusMin && this.biegeradius) {
            result.biegeradius = leitung.biegeradiusMin.mm <= this.biegeradius.mm;
        }
        const rbr = Number(this.indexBiegeradiusRBR);
        if (this.indexBiegeradiusRBR && this.indexBiegeradiusRBR.length > 0 && leitung.biegeradiusMin && !isNaN(rbr)) {
            result.rbr = leitung.biegeradiusMin.mm <= rbr;
        }
        return result;
    }
    /**
     * Checks if an `IA` can be contained by this `Kette` regarding its breite.
     *
     * @param iaBreite The breite property of the IA to check
     * @param iaArtikeltyp The Artikeltyp property of the IA
     * @param iaKetteSerieRef The KetteSerieRef property of the IA
     * @param tolerance A tolerance used by check
     * @returns Whether the breite is supported or not. Will be undefined if decision cannot be
     * made.
     */
    supportsIABreite(iaBreite, iaArtikeltyp, iaKetteSerieRef = [], tolerance = echain_shared_quantities_1.Length.mm(1)) {
        var _a;
        if (!iaArtikeltyp) {
            // if iaArtikeltyp does not exist, check KetteSerieRef with corresponding SerieId
            for (const ketteSerieRef of iaKetteSerieRef) {
                if (ketteSerieRef.id === ((_a = this.serieRef) === null || _a === void 0 ? void 0 : _a.id)) {
                    iaArtikeltyp = ketteSerieRef.artikeltyp;
                    break;
                }
            }
        }
        // do NOT check the width here!
        // .. böden can and will intersect the chain!
        // TODO: EKE-12701 make use of a switch case !!
        if (this.isSerieRxRohr()) {
            return true;
        }
        if (this.innenbreite && iaBreite && iaArtikeltyp) {
            if (iaArtikeltyp === echain_shared_articles_1.IAArtikeltyp.Einsteckboden) {
                return iaBreite.mm <= this.innenbreite.mm + tolerance.mm && iaBreite.mm >= this.innenbreite.mm - tolerance.mm;
            }
            else {
                return iaBreite.mm <= this.innenbreite.mm + tolerance.mm;
            }
        }
        return undefined;
    }
    /**
     * Retrieves whether calculations on verfahrweg using k or k2 are possible
     *
     * @returns If possible or not.
     */
    calculationBasedOnVerfahrwegNotPossible() {
        return ((this.langerWeg && (!this.k2 || this.k2.mm === 0)) ||
            (!this.langerWeg && (!this.k || this.k.mm === 0)) ||
            // TODO: EKE-12701 make use of a switch case !!
            this.isSerieTwisterchain());
    }
    /**
     * Retrieves the best available laenge of a kette.
     */
    getMostPreciseEffektiveLaenge() {
        return this.effektiveLaengeWithAEs || this.effektiveLaenge || this.laenge;
    }
    /**
     * Retrieves the best available laenge of a kette without AE l.
     */
    getMostPreciseEffektiveLaengeWithoutAELaenge() {
        return this.effektiveLaenge || this.laenge;
    }
    /**
     * Retrieves the best available weight of a kette.
     */
    getMostPreciseWeight() {
        if (this.gewichtKgProM && this.getMostPreciseEffektiveLaengeWithoutAELaenge()) {
            const laenge = this.getMostPreciseEffektiveLaengeWithoutAELaenge();
            if (laenge) {
                return echain_shared_quantities_1.Weight.kg(this.gewichtKgProM.kg_m * laenge.m);
            }
        }
        return undefined;
    }
    /**
     * Retrieves whether the Kette.gewichtKgProM is defined and greater than 0.
     */
    hasValidGewichtKgProM() {
        var _a;
        return Boolean(((_a = this.gewichtKgProM) === null || _a === void 0 ? void 0 : _a.kg_m) && this.gewichtKgProM.kg_m > 0);
    }
    /**
     * Retrieves the radius part of the indexBiegeradius
     *
     * @returns The radius
     */
    get indexBiegeradiusR() {
        var _a, _b;
        return (_b = (_a = this.indexBiegeradius) === null || _a === void 0 ? void 0 : _a.split('/').at(0)) !== null && _b !== void 0 ? _b : '';
    }
    /**
     * Retrieves the rückwärtiger radius part of the indexBiegeradius
     *
     * @returns The rückwärtiger radius
     */
    get indexBiegeradiusRBR() {
        var _a, _b;
        return (_b = (_a = this.indexBiegeradius) === null || _a === void 0 ? void 0 : _a.split('/').at(1)) !== null && _b !== void 0 ? _b : '';
    }
    /**
     * Sets the laenge calculation properties.
     */
    setLaengeCalculationProperties(props) {
        const lengthCalcInitializedBy = props.lengthCalcInitializedBy;
        const verfahrweg = props.verfahrweg;
        const laenge = props.laenge;
        const numGlieder = props.numGlieder;
        let langerWeg = props.langerWeg;
        let einspeisung = props.einspeisung;
        let versatz = props.versatz;
        let changed = false;
        if ('lengthCalcInitializedBy' in props && this.lengthCalcInitializedBy !== lengthCalcInitializedBy) {
            if (lengthCalcInitializedBy) {
                this.lengthCalcInitializedBy = lengthCalcInitializedBy;
            }
            else {
                this.lengthCalcInitializedBy = undefined;
            }
            changed = true;
        }
        if ('langerWeg' in props) {
            // map undefined => false (default construction value)
            if (langerWeg == null) {
                langerWeg = false;
            }
            if (!this.langerWeg && langerWeg) {
                if (this.gleitenderBetriebErlaubt == null || this.gleitenderBetriebErlaubt) {
                    this.langerWeg = langerWeg;
                    changed = true;
                }
            }
            else if (this.langerWeg && !langerWeg) {
                this.langerWeg = langerWeg;
                changed = true;
            }
        }
        if ('verfahrweg' in props && !echain_shared_quantities_1.Q.areEqual(this.verfahrweg, verfahrweg)) {
            if (verfahrweg) {
                this.verfahrweg = verfahrweg.clone();
            }
            else {
                this.verfahrweg = undefined;
            }
            changed = true;
        }
        if ('laenge' in props && !echain_shared_quantities_1.Q.areEqual(this.laenge, laenge)) {
            if (laenge) {
                this.laenge = laenge;
            }
            else {
                this.laenge = undefined;
            }
            changed = true;
        }
        if ('numGlieder' in props && this.numGlieder !== numGlieder) {
            if (numGlieder != null) {
                this.numGlieder = numGlieder;
            }
            else {
                this.numGlieder = undefined;
            }
            changed = true;
        }
        if ('einspeisung' in props) {
            // map undefined => mittigeEinspeisung (default construction value)
            if (!einspeisung) {
                einspeisung = echain_shared_articles_1.KetteEinspeisung.mittigeEinspeisung;
            }
            if (this.einspeisung === echain_shared_articles_1.KetteEinspeisung.mittigeEinspeisung &&
                einspeisung !== echain_shared_articles_1.KetteEinspeisung.mittigeEinspeisung) {
                if (this.versatzFestpunktErlaubt == null || this.versatzFestpunktErlaubt) {
                    this.einspeisung = einspeisung;
                    changed = true;
                }
            }
            else if (this.einspeisung !== echain_shared_articles_1.KetteEinspeisung.mittigeEinspeisung &&
                einspeisung === echain_shared_articles_1.KetteEinspeisung.mittigeEinspeisung) {
                this.einspeisung = einspeisung;
                this.versatz = echain_shared_quantities_1.Length.mm(0);
                changed = true;
            }
        }
        if ('versatz' in props) {
            // map undefined => Length.mm(0) (default construction value)
            if (!versatz) {
                versatz = echain_shared_quantities_1.Length.mm(0);
            }
            if (!echain_shared_quantities_1.Q.areEqual(this.versatz, versatz)) {
                if (this.einspeisung !== echain_shared_articles_1.KetteEinspeisung.mittigeEinspeisung) {
                    this.versatz = versatz.clone();
                    changed = true;
                }
                else if (!this.versatz || this.versatz.mm !== 0) {
                    this.versatz = echain_shared_quantities_1.Length.mm(0);
                    changed = true;
                }
            }
        }
        return changed;
    }
    /**
     * Merges a json into the object by not overwriting existing values
     *
     * @param json The json to patch in
     */
    mergeJson(json) {
        var _a, _b;
        echain_shared_validation_1.Validation.throws(echain_shared_validation_1.Validator.definedNotNull(json, 'Kette.merge: json: '));
        const pjson = {};
        for (const key in json) {
            const memberKey = key.charAt(0).toLowerCase() + (key.substring(1) || '');
            if (this[memberKey] == null) {
                pjson[key] = json[key];
            }
            else {
                // handle deep merges
                if (memberKey === 'serieRef') {
                    // we always update the serieRef if the kuerzel are equal
                    // this is necessary when the kette serie has been invented and lacks an id
                    if (((_a = this.serieRef) === null || _a === void 0 ? void 0 : _a.kuerzel) === ((_b = json.SerieRef) === null || _b === void 0 ? void 0 : _b.Kuerzel)) {
                        pjson.SerieRef = json.SerieRef;
                    }
                }
            }
        }
        // TODO (norman) remove hack. The description clearly says "not overwriting existing values"!
        // Please never do these kind of things without aligning
        // and if we need a hack, then please add a comment why we need it.
        if (json.MinDistKlemmO != null)
            pjson.MinDistKlemmO = json.MinDistKlemmO;
        if (json.MinDistKlemmU != null)
            pjson.MinDistKlemmU = json.MinDistKlemmU;
        if (json.MinDistO != null)
            pjson.MinDistO = json.MinDistO;
        if (json.MinDistU != null)
            pjson.MinDistU = json.MinDistU;
        if (json.RastPosDist != null)
            pjson.RastPosDist = json.RastPosDist;
        if (json.RastPosLeft != null)
            pjson.RastPosLeft = json.RastPosLeft;
        if (json.StaticIAArtikelRef != null)
            pjson.StaticIAArtikelRef = json.StaticIAArtikelRef;
        this.fromJson(pjson);
    }
    fromJson(json, cloneStrategy = 'deep', deepCloneSanitizeOptions = { removeNully: true }, doNotOverwritePropertyKeys = []) {
        var _a, _b, _c, _d;
        var _e;
        super.fromJson(json, cloneStrategy, deepCloneSanitizeOptions, doNotOverwritePropertyKeys);
        // TODO: EKE-10799 improve this. if there is none given, use 'default' !
        (_a = (_e = this.model).KetteSerieType) !== null && _a !== void 0 ? _a : (_e.KetteSerieType = echain_shared_articles_1.KetteSerieType.default);
        // TODO: check twiserband TB29 außenbreite !
        // EKE-8801
        if ((_b = this.artNr) === null || _b === void 0 ? void 0 : _b.startsWith('TB29')) {
            this.aussenbreite = echain_shared_quantities_1.Length.mm(46);
        }
        // TODO: move those mocks back to iPro!
        // EKE-8681
        if (this.isSerieRxRohr()) {
            const rxPatch = echain_shared_articles_1.rxRohrPatches.find((rrp) => { var _a; return rrp.serieRef === ((_a = this.serieRef) === null || _a === void 0 ? void 0 : _a.kuerzel); });
            if (rxPatch) {
                // we need to set this prop's, to not have more grid-points than we need!
                this.minDistO = echain_shared_quantities_1.Length.mm(rxPatch.minDist);
                this.minDistU = echain_shared_quantities_1.Length.mm(rxPatch.minDist);
                this.rastPosDist = echain_shared_quantities_1.Length.mm(rxPatch.rastPos);
                this.rastPosLeft = echain_shared_quantities_1.Length.mm(0);
                if (rxPatch.artSerieBreite) {
                    this.artSerieBreite = rxPatch.artSerieBreite;
                }
                const sIaLeft = {
                    IAHKB: { Unit: 'mm', Value: 3 },
                    IAHKBOT: { Unit: 'mm', Value: 0 },
                    IAHKDist: { Unit: 'mm', Value: 0 },
                    IAHKH: { Unit: 'mm', Value: 4.5 },
                    IAHKHeight: { Unit: 'mm', Value: 4.5 },
                    IAHKOLOH: { Unit: 'mm', Value: 0 },
                    IAHKRep: 1,
                    IAHKULUH: { Unit: 'mm', Value: 0 },
                    ArtyConnect: '2510',
                    ArtNr: { DE: ((_c = this.artSerieBreite) === null || _c === void 0 ? void 0 : _c.split('.')[0]) + '.2.1' },
                    YPos: { Unit: 'mm', Value: 0 },
                    ZPos: { Unit: 'mm', Value: 0 },
                };
                const sIaRight = Object.assign({}, sIaLeft);
                sIaLeft.XPos = { Unit: 'mm', Value: -sIaLeft.IAHKB.Value };
                const kettenBreite = ((_d = this.innenbreite) === null || _d === void 0 ? void 0 : _d.mm) || 0;
                sIaRight.XPos = { Unit: 'mm', Value: kettenBreite };
                this.staticIAArtikelRef = [StaticIA_1.StaticIA.fromJson(sIaLeft), StaticIA_1.StaticIA.fromJson(sIaRight)];
            }
        }
    }
    clone() {
        return this._clone(Kette.fromScratch());
    }
    duplicate() {
        return this._duplicate();
    }
    /**
     * Retrieves true if the inner shape of a Kette is a rect (and not an ellipsis, circle, etc.)
     */
    hasRectIaFillingShape() {
        return !this.hasNonRectIaFillingShape();
    }
    /**
     * Retrieves true if the inner shape of a Kette is complex (not a rect)
     * --> means: is an SVG used or not!
     */
    hasNonRectIaFillingShape() {
        switch (this.serieType) {
            case echain_shared_articles_1.KetteSerieType.triflexR:
            case echain_shared_articles_1.KetteSerieType.trxe:
            case echain_shared_articles_1.KetteSerieType.eskin:
            case echain_shared_articles_1.KetteSerieType.rxRohr:
            case echain_shared_articles_1.KetteSerieType.twisterband:
                return true;
            case echain_shared_articles_1.KetteSerieType.twisterchain:
            case echain_shared_articles_1.KetteSerieType.rolEchain:
            case echain_shared_articles_1.KetteSerieType.default:
                return false;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(this.serieType);
        }
    }
    /**
     * Retrieves true if Serie is a Triflex R serie
     */
    isSerieTriflexR() {
        return this.serieType === echain_shared_articles_1.KetteSerieType.triflexR;
    }
    /**
     * Retrieves true if Serie is a TRXE serie
     */
    isSerieTrxe() {
        return this.serieType === echain_shared_articles_1.KetteSerieType.trxe;
    }
    /**
     * Retrieves true if Serie is a e-Skin serie
     */
    isSerieESkin() {
        return this.serieType === echain_shared_articles_1.KetteSerieType.eskin;
    }
    /**
     * Retrieves true if Serie is a RX Rohre serie
     */
    isSerieRxRohr() {
        return this.serieType === echain_shared_articles_1.KetteSerieType.rxRohr;
    }
    /**
     * Retrieves true if Serie is a twisterband serie
     */
    isSerieTwisterband() {
        return this.serieType === echain_shared_articles_1.KetteSerieType.twisterband;
    }
    /**
     * Retrieves true if Serie is a twisterchain serie
     */
    isSerieTwisterchain() {
        return this.serieType === echain_shared_articles_1.KetteSerieType.twisterchain;
    }
    /**
     * Retrieves true if this Kette is only for a espool-system
     */
    isEspoolOnly() {
        var _a;
        return Boolean((_a = this.articleSpecs) === null || _a === void 0 ? void 0 : _a.includes(echain_shared_articles_1.ArticleSpecs.espoolOnly));
    }
    /**
     * Retrieves true if this Kette is only configurable for a rolEchain
     */
    isRolEchainOnly() {
        var _a;
        return Boolean((_a = this.articleSpecs) === null || _a === void 0 ? void 0 : _a.includes(echain_shared_articles_1.ArticleSpecs.rolEchainOnly));
    }
    /**
     * Retrieves true if Kette is a rol e-chain article
     */
    isSerieRolEchain() {
        return this.serieType === echain_shared_articles_1.KetteSerieType.rolEchain;
    }
    /**
     * Retrieves whether both kette have the same serie or not.
     *
     * This method tries to compare several properties in order:
     * - serieRef.id
     * - serieRef.kuerzel
     *
     * It will return false if it cannot compare because no properties are defined.
     */
    hasSameSerie(other) {
        if (this.serieRef && other.serieRef) {
            if (this.serieRef.id && other.serieRef.id && this.serieRef.id === other.serieRef.id) {
                return true;
            }
            if (this.serieRef.kuerzel && other.serieRef.kuerzel && this.serieRef.kuerzel === other.serieRef.kuerzel) {
                return true;
            }
        }
        else if (!this.serieRef && !other.serieRef) {
            return undefined;
        }
        return false;
    }
    /**
     * Determines if the given Trennsteg is the Standard Trennsteg of the Kette.
     *
     * @param ia The given Trennsteg
     */
    isStandardTrennsteg(ia) {
        return !!(this.standardTrennstegArtNr && ia.isReferencedByArtNr(this.standardTrennstegArtNr));
    }
    isRolEchain() {
        var _a;
        return this.isSerieRolEchain() && Boolean((_a = this.articleSpecs) === null || _a === void 0 ? void 0 : _a.includes(echain_shared_articles_1.ArticleSpecs.rolEchain));
    }
    isRolEchainRolLink() {
        var _a;
        return Boolean((_a = this.articleSpecs) === null || _a === void 0 ? void 0 : _a.includes(echain_shared_articles_1.ArticleSpecs.rolEchainRolLink));
    }
    isRolEchainAdapterLink() {
        var _a;
        return Boolean((_a = this.articleSpecs) === null || _a === void 0 ? void 0 : _a.includes(echain_shared_articles_1.ArticleSpecs.rolEchainAdapterLink));
    }
    isRolEchainModifiedLink() {
        var _a;
        return Boolean((_a = this.articleSpecs) === null || _a === void 0 ? void 0 : _a.includes(echain_shared_articles_1.ArticleSpecs.rolEchainModifiedLink));
    }
    isRolEchainAutoglideLink() {
        var _a;
        return Boolean((_a = this.articleSpecs) === null || _a === void 0 ? void 0 : _a.includes(echain_shared_articles_1.ArticleSpecs.rolEchainAutoglideLink));
    }
    /**
     * @deprecated use KetteJsonUtils instead.
     */
    getESkinAeExcessLength() {
        if (!this.serieRef || !this.serieRef.kuerzel) {
            throw new Error('Kette.getESkinAeExcessLength: serieRef not set correct');
        }
        if (!this.isSerieESkin()) {
            throw new Error('Kette.getESkinAeExcessLength: Kette is not a e-skin');
        }
        const excessLength = echain_shared_articles_1.eSkinAeExcessLengthMap.get(this.serieRef.kuerzel);
        if (excessLength) {
            return echain_shared_quantities_1.Length.mm(excessLength);
        }
        throw new Error('Kette.getESkinAeExcessLength: Invalid excessLength');
    }
}
exports.Kette = Kette;
//# sourceMappingURL=Kette.js.map